import { Component, Input } from '@angular/core';
import { PropertyType } from '../../../../shared/models/property-type';

@Component({
  selector: 'app-address-read-mode',
  templateUrl: './address-read-mode.component.html',
  styleUrls: ['./address-read-mode.component.scss']
})
export class AddressReadModeComponent {

  @Input() addressInput! : string;
  @Input() propertyType! : PropertyType;

}
